import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnackbarService } from './../../../../services/snackbar.service';
import { ILot, TValue } from './../../../../models/generic';
import { ApiManualBatchService } from './../../../../services/api/api-manual-batch.service';
import {
  IBeneficiaryEconomicGroup,
  IBeneficiaryForm,
  IEconomicGroupUnit
} from 'src/app/models/manual-batch';
import { debounceTime, distinctUntilChanged } from 'rxjs';

const CNPJ_LENGTH: number = 14;

@Component({
  selector: 'app-payment-beneficiary-dialog',
  templateUrl: './payment-beneficiary-dialog.component.html',
  styleUrls: ['./payment-beneficiary-dialog.component.scss']
})
export class PaymentBeneficiaryDialogComponent implements OnInit {
  form!: FormGroup<IBeneficiaryForm>;

  // economicGroupUnits: IEconomicGroupUnit[] = [];
  // beneficiaryDocuments: string[] = [];

  constructor(
    private _manualBatchService: ApiManualBatchService,
    @Inject(MAT_DIALOG_DATA) public data: ILot,
    private _dialogRef: MatDialogRef<PaymentBeneficiaryDialogComponent>,
    private _snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    //this.getEconomicGroupUnits();
    this.buildForm();
  }

  // getEconomicGroupUnits(partnerDocument:string): void {
  //   this._manualBatchService
  //     .getEconomicGroupUnits(
  //       partnerDocument.replace(/[^\w\s]/gi, '')!
  //     )
  //     .subscribe({
  //       next: (response) => {
  //         if (response.length > 0) {
  //           this.economicGroupUnits = [...response];
  //           this.handleEconomicGroupUnits(response);
  //         }
  //       }
  //     });
  // }

  // handleEconomicGroupUnits(units: IEconomicGroupUnit[]): void {
  //   this.beneficiaryDocuments = units.map((unit) => {
  //     return unit.CNPJ?.replace(
  //       /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
  //       '$1.$2.$3/$4-$5'
  //     );
  //   });
  // }

  buildForm(): void {
    this.form = new FormGroup<IBeneficiaryForm>({
      Document: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(CNPJ_LENGTH)]
      }),
      BeneficiaryName: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      Comission: new FormControl<number | null>(null, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });

    this.form.controls['BeneficiaryName'].disable();
    this.form.controls['Comission'].disable();

    this.listenDocumentValue();
  }

  listenDocumentValue(): void {
    this.form.controls['Document'].valueChanges
      .pipe(
        debounceTime(400), // espera 400ms após o usuário parar de digitar.
        distinctUntilChanged() // só emite se o valor atual for diferente do último.
      )
      .subscribe(cnpj => {

        //CNPJ Grupo: this.data.PartnerDocument

        if (cnpj.length === CNPJ_LENGTH) {

          let cnpjOnlyLettersNumber: string = cnpj.replace(/[^a-zA-Z0-9]/g, '')!;

          this._manualBatchService
            .getEconomicGroupPartner(cnpjOnlyLettersNumber)
            .subscribe({
              next: (response) => {
                if(response) {
                  this.form.controls['BeneficiaryName'].setValue(response.RazaoSocial);
                  this.form.controls['Comission'].setValue(response.Aliquota);
                }

                // if (response.length > 0) {
                  // this.economicGroupUnits = [...response];
                  // this.handleEconomicGroupUnits(response);
                // }
              }
            });
        }
        else{
          this.resetFormValues();
        }
      });

    // this.form.controls['Document'].valueChanges.subscribe({
    //   next: (cnpj) => {
    //     if (cnpj.length === CNPJ_LENGTH) {
    //       this.setFormValuesByDocument(cnpj);
    //     } else {
    //       this.resetFormValues();
    //     }
    //   }
    // });
  }

  // setFormValuesByDocument(cnpj: string): void {
  //   let beneficiary: IEconomicGroupUnit | null = this.matchBeneficiary(cnpj);
  //   if (beneficiary) {
  //     this.form.controls['BeneficiaryName'].setValue(beneficiary.RazaoSocial);
  //     this.form.controls['Comission'].setValue(beneficiary.Aliquota);
  //   } else {
  //     this.resetFormValues();
  //   }
  // }

  // matchBeneficiary(cnpj: string): IEconomicGroupUnit | null {
  //   let beneficiary: IEconomicGroupUnit | null = this.economicGroupUnits.find(
  //     (unit) => {
  //       return (
  //         cnpj.replace(/[^\w\s]/gi, '') === unit.CNPJ?.replace(/[^\w\s]/gi, '')
  //       );
  //     }
  //   ) as IEconomicGroupUnit;

  //   return beneficiary;
  // }

  resetFormValues(): void {
    this.form.controls['BeneficiaryName'].setValue('');
    this.form.controls['Comission'].setValue(null);
  }

  saveBeneficiary(): void {
    const beneficiary = this.form.getRawValue() as IBeneficiaryEconomicGroup;

    this._manualBatchService
      .updateBeneficiaryEconomicGroup(this.data.BatchId.toString(), beneficiary)
      .subscribe({
        next: (response) => {
          this._snackbarService.openSnackBar(
            'Beneficiário alterado com sucesso!',
            'success'
          );
          this._dialogRef.close(beneficiary);
        }
      });
  }
}
